// extracted by css-extract-rspack-plugin
export default {"content":"SharedPageLayout-module__content__IwGAp"};